import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Upload, Button } from "antd";
import "./style.scss";
import Storelist from "../../Store/Actions";
import {
  CloseOutlined,
  CodeSandboxCircleFilled,
  UploadOutlined,
  DeleteOutlined 
} from "@ant-design/icons";
import Api from "../../Utils/Api";
import useApiGet from "../../Hooks/useGet";
import { BASE_URL_API, BASE_URL_API2, roles } from "../../appconfig";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const EditTechnician = () => {
  const { PageStore, editTechnician, CreateRequestDetailsStore } = Storelist();
  const [defaultValues, setDefaultValues] = useState({});
  const [form] = Form.useForm();
  const GetServiceMan = useApiGet();
  const formdata = new FormData();
  const { EditTechnician } = Api();

  useEffect(() => {
    if (PageStore?.edit_Technician) {
      GetServiceMan.Getdata(
        `${BASE_URL_API()}serviceman?id=${PageStore?.edit_Technician}`,
        true
      );
    }
  }, [PageStore?.edit_Technician]);

  useEffect(() => {
    if (GetServiceMan.data !== null) {
      if (GetServiceMan.data.status === 200) {
        console.log(GetServiceMan?.data?.body?.data);
        const data = GetServiceMan?.data?.body?.data;

        form.setFieldsValue({
          name: data?.name,
          emailId: data?.emailId,
          mobileNumber: data?.mobileNumber,
          emergencyPhone: data?.emergencyPhone,
          employeeId: data?.employeeId,
          branch: data?.branch?._id,
          role: data?.role,
          profileImage: data?.profileUrl
            ? [
                {
                  uid: "-1",
                  name: "profile.png",
                  status: "done",
                  url: data?.profileUrl,
                },
              ]
            : null,
          drivingLicense: data?.drivingLicenseUrl
            ? [
                {
                  uid: "-1",
                  name: "license.png",
                  status: "done",
                  url: data?.drivingLicenseUrl,
                },
              ]
            : null,
          aadharCard: data?.adhaarUrl
            ? [
                {
                  uid: "-1",
                  name: "Aadhar.png",
                  status: "done",
                  url: data?.adhaarUrl,
                },
              ]
            : null,
          // You can map other fields as needed
        });

        setDefaultValues({
          name: data?.name,
          emailId: data?.emailId,
          mobileNumber: data?.mobileNumber,
          emergencyPhone: data?.emergencyPhone,
          employeeId: data?.employeeId,
          branch: data?.branch?._id,
          role: data?.role,
          profileImage: data?.profileUrl
            ? [
                {
                  uid: "-1",
                  name: "profile.png",
                  status: "done",
                  url: data?.profileUrl,
                },
              ]
            : null,
          drivingLicense: data?.drivingLicenseUrl
            ? [
                {
                  uid: "-1",
                  name: "license.png",
                  status: "done",
                  url: data?.drivingLicenseUrl,
                },
              ]
            : null,
          aadharCard: data?.adhaarUrl
            ? [
                {
                  uid: "-1",
                  name: "Aadhar.png",
                  status: "done",
                  url: data?.adhaarUrl,
                },
              ]
            : null,
        });
      }
    }
  }, [GetServiceMan?.data]);
  

  const submitForm = (data) => {
    formdata.append("id", PageStore?.edit_Technician);
    if (data.name) formdata.append("name", data?.name);
    if (data?.emailId) formdata.append("emailId", data?.emailId);
    if (data?.mobileNumber) formdata.append("mobileNumber", data?.mobileNumber);
    if (data?.emergencyPhone)
      formdata.append("emergencyPhone", data?.emergencyPhone);
    if (data?.employeeId) formdata.append("employeeId", data?.employeeId);
    if (data?.role) formdata.append("role", data?.role);
    if (data?.profileImage)
      formdata.append("profileImage", data?.profileImage[0]?.originFileObj);
    if (data?.drivingLicense)
      formdata.append("drivingLicense", data?.drivingLicense[0]?.originFileObj);
    if (data?.aadharCard)
      formdata.append("aadharCard", data?.aadharCard[0]?.originFileObj);

    console.log(formdata);
    EditTechnician(formdata);
  };

  const onFinish = (values) => {
    if (!defaultValues) return;

    const changedData = {};

    for (const key in values) {
      const newVal = values[key];
      const oldVal = defaultValues[key];

      // Special handling for Upload fields
      if (
        key === "profileImage" ||
        key === "drivingLicense" ||
        key === "aadharCard"
      ) {
        // Extract URLs or names from current form value
        const newUrl =
          newVal?.[0]?.url ||
          newVal?.[0]?.thumbUrl ||
          newVal?.[0]?.originFileObj?.name ||
          null;

        // The original (default) image URL key, e.g., defaultValues.profileImageUrl
        const oldUrl =
          defaultValues?.[key + "Url"] ||
          defaultValues?.[key]?.[0]?.url ||
          null;

        // ✅ Compare the actual URL/filename, not the object
        if (newUrl !== oldUrl) {
          changedData[key] = newVal; // you can also just pass newUrl if needed
        }
        continue;
      }

      // Handle nulls and simple values
      if (newVal == null && oldVal == null) continue;

      if (newVal !== oldVal) {
        changedData[key] = newVal;
      }
    }

    // console.log("🟢 Changed fields only:", changedData);
    if (Object.keys(changedData).length !== 0) {
      // console.log("Entereing");
      submitForm(changedData);
    }
    else{
      toast.warn("change atlease any one field before proceed",{position:"top-center"})
    }
  };

  return (
    <Modal
      closeIcon={
        <CloseOutlined
          style={{
            border: "1px solid black",
            borderRadius: "10px",
            padding: "4px",
            color: "black",
            fontSize: "18px",
            backgroundColor: "white",
          }}
        />
      }
      maskClosable={false}
      keyboard={false}
      onCancel={() => {
        editTechnician("");
        form.resetFields();
      }}
      open={PageStore?.edit_Technician}
      footer={null}
      //   destroyOnHidden
    >
      <div className="w-[100%] h-[100%] border  relative">
        
        <div className="text-center text-xl font-semibold">Edit Superstar</div>

        <Form
          layout={"vertical"}
          form={form}
          initialValues={{ layout: "vertical" }}
          onFinish={onFinish}
          style={{
            maxWidth: "vertical" === "inline" ? "none" : "80%",
            marginLeft: "10%",
          }}
          className=" w-[100%]"
          requiredMark={false}
        >
          <Form.Item
            label={
              <span>
                Name 
              </span>
            }
            name={"name"}
            // rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input placeholder="Enter Employee Full Name" />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Email Id 
              </span>
            }
            name={"emailId"}
            rules={[
              // { required: true, message: "Please enter Employee email" },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input
              label="Email"
              placeholder="Enter Employee Email"
              name="email"
            />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Phone Number 
              </span>
            }
            name={"mobileNumber"}
            rules={[
              // { required: true, message: "Please input Phone Number" },
              {
                pattern: /^\d{10}$/, // regex → exactly 10 digits
                message: "Phone number must be exactly 10 digits",
              },
            ]}
          >
            <Input
              style={{ width: "100%" }}
              controls={false}
              placeholder="Enter Employee phonenumber"
              // onChange={(e) => {
              //   handleChange("phoneNumber", e);
              // }}
              // onPaste={handlePaste}
            />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Emergency Contact 
              </span>
            }
            name={"emergencyPhone"}
            rules={[
              // { required: true, message: "Please input Phone Number" },
              {
                pattern: /^\d{10}$/,
                message: "Phone number must be exactly 10 digits",
              },
            ]}
          >
            <Input
              style={{ width: "100%" }}
              controls={false}
              placeholder="Enter Employee Emergency Contact"
              // onChange={(e) => {
              //   handleChange("emergencyContact", e);
              // }}
              // onPaste={handlePaste}
            />
          </Form.Item>

          <Form.Item
            label={
              <span>
                Employee ID
              </span>
            }
            name={"employeeId"}
            // rules={[{ required: true, message: "Please input Employee ID" }]}
          >
            <Input placeholder="Enter Employee ID" />
          </Form.Item>

          <Form.Item
            label="Branch"
            name={"branch"}
            // initialValue={CreateRequestDetailsStore?.branchDetail?._id}
            rules={[{ required: true, message: "Please input Branch" }]}
          >
            <Select placeholder="select branch">
              <Select.Option
                value={CreateRequestDetailsStore?.branchDetail?._id}
              >
                {CreateRequestDetailsStore?.branchDetail?.branchName}
              </Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <span>
                Role
              </span>
            }
            name={"role"}
            // rules={[{ required: true, message: "Please input Employee ID" }]}
          >
            <Select placeholder="select role">
              {roles?.map((item, index) => (
                <Select.Option key={index} value={item.id}>
                  {item.role}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={
              <span>
                Profile Image<span style={{ color: "red" }}>*</span>
              </span>
            }
            name="profileImage"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              // e is the Upload event
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
            // rules={[{ required: true, message: "Profile Image Required!" }]}
          >
            <Upload.Dragger
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                if (!isImage) {
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              accept="image/*"
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item
            label="Aadhar    Card"
            name="aadharCard"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
          >
            <Upload.Dragger
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                if (!isImage) {
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              maxCount={1}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item
            label="Driving License"
            name="drivingLicense"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              // e is the Upload event
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
          >
            <Upload.Dragger
              beforeUpload={(file) => {
                const isImage = file.type.startsWith("image/");
                if (!isImage) {
                  return Upload.LIST_IGNORE;
                }
                return false;
              }}
              maxCount={1}
              accept="image/*"
              multiple={false}
            >
              <p className="ant-upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Upload.Dragger>
          </Form.Item>

          <Form.Item className=" flex justify-center">
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default EditTechnician;
